// Category images are editorial AI illustrations, never evidence of completed customer work.
export const CATEGORY_PHOTOS = {
  ev_charger: '/media/illustrations/ev-smart-home-480.webp',
  generator: '/media/illustrations/generators-480.webp',
  panel_upgrade: '/media/illustrations/construction-480.webp',
  lighting: '/media/illustrations/residential-480.webp',
  outlets_switches: '/media/illustrations/residential-480.webp',
  smart_home: '/media/illustrations/ev-smart-home-480.webp',
  new_construction: '/media/illustrations/construction-480.webp',
  residential_repairs: '/media/illustrations/residential-480.webp',
  commercial: '/media/illustrations/commercial-480.webp',
};
